import React from 'react';
import {
  PricingSection,
  PriceRow,
  PriceLabel,
  PriceValue,
  TotalRow,
  PlanBadge
} from '../styles';
import { PrinterItem } from 'src/utils/Products/productFilter';
import { useTranslationWithInterpolation } from 'src/hooks/useTranslationWithValues/useTranslationWithValuesHelper';
import { formatPrice } from 'src/utils/Products/getCalculatePriceDifferance';

interface PlanCostDetailsProps {
  selectedPrinterDetails?: PrinterItem;
}

const PlanCostDetails: React.FC<PlanCostDetailsProps> = ({
  selectedPrinterDetails
}) => {
  const { getText, getTextWithValues } = useTranslationWithInterpolation();

  const calculatePricingFromPrinter = () => {
    if (selectedPrinterDetails && selectedPrinterDetails.inkPlan?.length > 0) {
      const selectedPlan =
        selectedPrinterDetails.inkPlan.find((plan) => plan.recommendedPlan) ||
        selectedPrinterDetails.inkPlan[0];

      const subtotalValue = selectedPlan.totalPrice || 0;
      const taxAmount = subtotalValue * 0.1; // Assuming 10% tax rate
      const totalAmount = subtotalValue + taxAmount;

      return {
        subtotal: {
          label: getText('planSummary.pricing.subtotal.label', 'Subtotal'),
          value: getTextWithValues(
            'planSummary.pricing.subtotal.value',
            '{{amount}}/month',
            {
              amount: formatPrice(Math.abs(subtotalValue))
            }
          )
        },
        shipping: {
          label: getText('planSummary.pricing.shipping.label', 'Shipping'),
          value: getText('planSummary.pricing.shipping.value', 'Included')
        },
        tax: {
          label: getText('planSummary.pricing.tax.label', 'Tax'),
          value: getTextWithValues(
            'planSummary.pricing.tax.value',
            '{{amount}}',
            {
              amount: formatPrice(Math.abs(taxAmount))
            }
          )
        },
        total: {
          label: getText('planSummary.pricing.total.label', 'Total'),
          value: getTextWithValues(
            'planSummary.pricing.total.value',
            '{{amount}}/month',
            {
              amount: formatPrice(Math.abs(totalAmount))
            }
          )
        }
      };
    }
  };

  // Use provided pricing data or calculate from printer details
  const pricing = calculatePricingFromPrinter();

  return (
    <>
      <PricingSection>
        <PriceRow>
          <PriceLabel>{pricing.subtotal.label}</PriceLabel>
          <PriceValue>{pricing.subtotal.value}</PriceValue>
        </PriceRow>
        <PriceRow>
          <PriceLabel>{pricing.shipping.label}</PriceLabel>
          <PlanBadge>{pricing.shipping.value}</PlanBadge>
        </PriceRow>
        <PriceRow>
          <PriceLabel>{pricing.tax.label}</PriceLabel>
          <PriceValue>{pricing.tax.value}</PriceValue>
        </PriceRow>
      </PricingSection>
      <TotalRow>
        <PriceLabel>
          <b>{pricing.total.label}</b>
        </PriceLabel>
        <PriceValue>
          <b>{pricing.total.value}</b>
        </PriceValue>
      </TotalRow>
    </>
  );
};

export default PlanCostDetails;
